import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type SupportedLocale } from './direction';

export const PERSISTED_LOCALE_STORAGE_KEY = 'dukanti_locale';

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function normalizeLocale(
  raw: string | undefined | null,
  fallback: SupportedLocale = DEFAULT_LOCALE,
): SupportedLocale {
  if (!raw) return fallback;
  const base = raw.split('-')[0];
  if (!base) return fallback;
  return isSupportedLocale(base) ? base : fallback;
}

export function readStoredLocalePreference(): SupportedLocale | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(PERSISTED_LOCALE_STORAGE_KEY);
    return isSupportedLocale(raw) ? raw : null;
  } catch {
    // Private mode / storage disabled — fall through to the caller's default.
    return null;
  }
}

export function readPersistedLocale(fallback: SupportedLocale = DEFAULT_LOCALE): SupportedLocale {
  return readStoredLocalePreference() ?? fallback;
}

export function writePersistedLocale(locale: SupportedLocale): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PERSISTED_LOCALE_STORAGE_KEY, locale);
  } catch {
    // Private mode / storage disabled — the in-memory language still works.
  }
}
